import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root:{
    height: '100vh',
  },
  text: {
    marginTop: '5vh',
    marginRight: '10%',
    marginLeft: '10%',
  },
  header: {
    marginTop: theme.spacing(5),
  },
  title: {
    fontStyle: 'italic',
    fontWeight: 700,
  },
  tertiaryTitle: {
    color: theme.palette.tertiary.main,
  },
}));
